import * as React from 'react';
import * as main from '../../main.module.scss';
import * as cost from './style.module.scss';
import { TaxDeduction } from '../../../../TaxDeduction';
import { Modal } from '../../../../Modal';
export const Cost = ({ widgetOtl, widgetIndi, sravni }) => {
  const [showModalOtl, setShowModalOtl] = React.useState(false);
  const [showModalIndi, setShowModalIndi] = React.useState(false);
  return (
    <section className={cost.cost} id={'widget'}>
      <div className="container">
        <div className={cost.inner}>
          <h2 className={main.title}>Сколько стоит курс «Учись учиться. Начало»</h2>
          <ul>
            <li className={cost.otl}>
              <h3>Пакет «Отличник»</h3>
              <ul>
                <li>Доступ к курсу на&nbsp;2&nbsp;года</li>
                <li>Беспроцентная рассрочка на&nbsp;10&nbsp;месяцев</li>
              </ul>
              <div className={cost.price}>
                <h4>Стоимость</h4>
                <p className={cost.oldPrice}>179&nbsp;700&nbsp;₽</p>
                <p className={cost.newPrice}>99&nbsp;900&nbsp;₽</p>
              </div>
              <button
                className={main.btn}
                onClick={() => {
                  setShowModalOtl(true);
                }}
              >
                Купить курс
              </button>
            </li>
            <li className={cost.indi}>
              <h3>Индивидуальное обучение</h3>
              <ul>
                <li>Доступ к курсу на&nbsp;2&nbsp;года</li>
                <li>165 академических часов индивидуальных занятий</li>
              </ul>
              <div className={cost.price}>
                <h4>Стоимость</h4>
                <p className={cost.newPrice}>1&nbsp;500&nbsp;000&nbsp;₽</p>
              </div>
              <button
                className={main.consultBtn}
                onClick={() => {
                  setShowModalIndi(true);
                }}
              >
                Записаться на консультацию
              </button>
            </li>
          </ul>
          <p className={cost.undertext}>Все наши курсы можно оплатить материнским капиталом</p>
          <TaxDeduction className={cost.undertext} linkInner={sravni} />
        </div>
      </div>

      <Modal
        open={showModalOtl}
        onClose={() => {
          setShowModalOtl(false);
        }}
      >
        {widgetOtl}
      </Modal>
      <Modal
        open={showModalIndi}
        onClose={() => {
          setShowModalIndi(false);
        }}
      >
        {widgetIndi}
      </Modal>
    </section>
  );
};
